<div id="goliza" class="w-100-p h-100-p" fxLayout="column" fxLayoutAlign="space-between center" fusePerfectScrollbar>
    <div fxLayout="row" class="w-100-p" ngClass.xs="w-320" fxLayoutAlign="space-between start">
        <div *ngIf="golizaForm" fxLayout="column" class="w-100-p text-center">
            <div class="text-center mt-10" ngClass.gt-xs="">
                <img class="goliza-logo" src="assets/images/backgrounds/main-logo.png">
            </div>
            <div class="w-100-p text-center" fxLayout="column" ngClass.xs="mt-64" ngClass.gt-xs="mt-64">
                <p class="fuse-white-fg h6 mb-0">
                    Folio:
                </p>
                <p class="ticket-folio fuse-white-fg h1 mt-0 ">
                    {{folio}}
                </p>
            </div>
            <div *ngIf="!isExists else ticketExists">
                <div *ngIf="!isFinished else finishedMessage" class="w-100-p" fxLayout="column"
                    fxLayoutAlign="start center">
                    <div class="" ngClass.gt-xs="w-532" ngClass.xs="w-320" fxLayout="column"
                        fxLayoutAlign="start center" *ngIf="isValidFolio else invalidFolio">
                        <form [formGroup]="golizaForm" class="" ngClass.gt-xs="w-532" ngClass.xs="w-320"
                            fxLayout="column">
                            <mat-form-field appearance="outline">
                                <mat-label>Correo electrónico</mat-label>
                                <input matInput placeholder="tu@email.com" maxlength="128" formControlName="email">
                                <mat-icon matSuffix>mail</mat-icon>
                                <mat-error *ngIf="f.email.hasError('required')">Correo electronico requerido</mat-error>
                            </mat-form-field>
                            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap.gt-xs="12px" class="w-100-p">
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Nombre</mat-label>
                                    <input matInput placeholder="" maxlength="128" formControlName="fullName">
                                    <mat-error *ngIf="f.fullName.hasError('required')">Nombre requerido</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Teléfono</mat-label>
                                    <input matInput placeholder="1122334455" maxlength="10"
                                        formControlName="phoneNumber">
                                    <mat-icon matSuffix>local_phone</mat-icon>
                                    <mat-error *ngIf="f.phoneNumber.hasError('required')">Teléfono requerido</mat-error>
                                </mat-form-field>
                            </div>
                        </form>
                        <div class="text-center">
                            <p class="mb-0 mt-4">
                                <em class="h1 fuse-white-fg">
                                    ¿EN QUE CIUDAD SE INAUGURÓ NUESTRA
                                </em>
                            </p>
                            <p class="mt-0">
                                <em class="h1 fuse-white-fg text-bold">
                                    PRIMERA SUCURSAL?
                                </em>
                            </p>
                        </div>
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" fxLayoutGap="16px"
                            class="fuse-white-fg attemp-box">
                            <div fxLayout="column" class="text-center h-100-p mt-12" fxLayoutAlign="center start">
                                <p class="m-0 h6">
                                    Oportunidades
                                </p>
                                <p class="m-0 h2 attemps w-100-p">
                                    {{attempts.length}}/{{attemptCount}}
                                </p>
                            </div>
                            <div *ngIf="this.attempts.length < this.attemptCount else finished ">
                                <mat-form-field appearance="standard" class="w-180">
                                    <input matInput placeholder="99999" maxlength="10" type="number"
                                        [formControl]="attemptControl" (keyup.enter)="add()">
                                    <mat-icon matSuffix>blur_circular</mat-icon>
                                    <mat-hint class="w-100-p h-16  text-center">Num. Figuras</mat-hint>
                                </mat-form-field>
                            </div>
                            <div *ngIf="this.attempts.length < this.attemptCount">
                                <button mat-button class="border-button mt-12" (click)="add()"
                                    [disabled]="attemptControl.invalid">
                                    Aceptar
                                </button>
                            </div>
                        </div>                        
                        <div class="text-center mt-32 mb-24">
                            <button mat-button class="fuse-white-bg" (click)="finish()" [disabled]="isSaving">
                                Finalizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<ng-template #finished>
    <div fxLayout="column" class="text-right">
        <p class="h2 m-0">Oportunidades agotadas 😁</p>
        <p class="h5 m-0">Presiona "Finalizar" para confirmar tu participación</p>
    </div>
</ng-template>

<ng-template #invalidFolio>
    <div fxLayout="column" class="text-center  mb-56 pr-24 pl-24 mt-56">
        <p class="h1 m-0 fuse-white-fg">Folio inválido 🥺</p>
        <p class="h5 m-0 fuse-white-fg">Tu folio no cumple con las caracteristicas necesarias para participar o es
            incorrecto</p>
        <div class="mt-8">
            <button mat-button class="fuse-white-bg" (click)="return()">
                Regresar
            </button>
        </div>
    </div>
</ng-template>

<ng-template #finishedMessage>
    <div fxLayout="column" class="text-center mb-56 pr-24 pl-24 mt-56">
        <p class="h1 m-0 text-center fuse-white-fg">Folio registrado 😉</p>
        <p class="h5 m-0 text-center fuse-white-fg">Tu folio y participación han sido registradas exitosamente</p>
        <div class="mt-8">
            <button mat-button class="fuse-white-bg" (click)="return()">
                Regresar
            </button>
        </div>
    </div>
</ng-template>

<ng-template #ticketExists>
    <div fxLayout="column" class="text-center mb-56 pr-24 pl-24 mt-56">
        <p class="h1 m-0 text-center fuse-white-fg">Folio registrado previamente 🙃</p>
        <p class="h5 m-0 text-center fuse-white-fg">Tu folio y participación ya se encuentran registrados en la urna
            maestra</p>
        <div class="mt-8">
            <button mat-button class="fuse-white-bg" (click)="return()">
                Regresar
            </button>
        </div>
    </div>
</ng-template>